import { NgModule } from '@angular/core';
import { CommonModule, PlatformLocation } from '@angular/common';
import { DEPLOY_URL, ENV } from '@core/interface/environment.interface';
import { langInstances } from 'environments/products/lang-instances';

import { environment } from 'environments/environment';

import { LocaleModule } from '../locale/locale.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        LocaleModule.forChild(environment)
    ],
    providers: [
        {
            provide: ENV,
            useFactory: () => {
                environment.langInstanceConfig = langInstances[environment.langInstance];
                return environment;
            }
        },
        //         {   // refactor
        //             provide: DEPLOY_URL,
        //             useFactory: (s: PlatformLocation) => {
        //                 if (s.getBaseHrefFromDOM()) {
        //                     return s.getBaseHrefFromDOM();
        //                 }
        //
        //                 if ((document as any).aemIntegrationAppServerURL) {
        //                     return (document as any).aemIntegrationAppServerURL
        //                 }
        //
        //                 return null
        //             },
        //             deps: [PlatformLocation]
        //         },
    ]
})
export class EnvironmentModule {
}
